module.exports = __webpack_public_path__ + "tiktok.f4cec30d9308f00af8cf0f1c2edb818f.svg";